import * as React from 'react';

import { type MarketingStatusTag, topAiProgramColors } from 'bundles/product-card/components/utils/marketingTagUtils';
import Badge from 'bundles/unified-description-page-common/components/shared/badges/Badge';
import NewAiBadge from 'bundles/unified-description-page-common/components/shared/badges/NewAiBadge';
import useShouldShowMerchPills from 'bundles/unified-description-page-common/hooks/useShouldShowMerchPills';
import { shouldShowNewAiSkillsBadge } from 'bundles/unified-description-page-common/utils/shouldShowNewAiSkillsBadge';

type Props = {
  marketingTag: MarketingStatusTag;
  slug: string | undefined;
};

const TopAiProgramBadge = ({ marketingTag, slug }: Props) => {
  const shouldShowMerchPills = useShouldShowMerchPills();

  if (shouldShowMerchPills) {
    return <Badge color={topAiProgramColors}>{marketingTag.tag}</Badge>;
  }
  return shouldShowNewAiSkillsBadge(slug) ? <NewAiBadge slug={slug} /> : null;
};

export default TopAiProgramBadge;
